module.exports = __webpack_public_path__ + "static/img/map.7e9b195.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map.svg
// module id = 026T
// module chunks = 0